<div bsModal
     #productSelectorModal="bs-modal"
     class="modal fade"
     tabindex="-1"
     role="dialog"
     aria-labelledby="productSelectorModal"
     aria-hidden="true" [config]="{backdrop: 'static', keyboard: !saving}">

    <div class="modal-dialog">
        <div class="modal-content" *ngIf="article">

            <div class="modal-header">
                <h5 class="modal-title" style="cursor: pointer;" (click)="toggleItemDetailModal()">
                    {{ article?.title }}
                    <i class="fa fa-eye"></i>
                </h5>

                <button type="button" class="close" (click)="close()" [attr.aria-label]="l('Close')" [disabled]="saving">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <!-- Price Section -->
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <div class="d-flex justify-content-between align-items-center gap-3">
                        <div>
                            <i class="pi pi-money-bill"></i> {{ article?.price }}
                        </div>
                        <div *ngIf="article?.purchasePrice">
                            <i class="pi pi-cart-plus"></i> {{ article?.purchasePrice }}
                        </div>
                    </div>
                    <div class="p-d-flex gap-2">
                        <i class="pi pi-shopping-cart"></i>
                        <ng-container *ngIf="isInBasket(article); else emptyBasket">
                            <span>{{ getBasketAmount(article) }}</span>
                        </ng-container>
                        <ng-template #emptyBasket>
                            <span>0</span>
                        </ng-template>
                    </div>
                </div>

                <ng-container *ngIf="article?.advisedAmount?.length > 0">
                    <!-- Quick Add Section -->
                    <div class="mb-3 p-3 bg-light">
                        <app-quick-add
                            [article]="article"
                            [quickAddAmounts]="quickAddAmounts"
                            (onQuickAction)="addToBasket($event)"></app-quick-add>
                    </div>

                    <p-divider align="center">
                        <span class="p-tag">OR</span>
                    </p-divider>
                </ng-container>

                <!-- Amount Section -->
                <div class="mb-3 p-3 bg-light text-center">
                    <h6 class="fw-bold">Amount</h6>
                    <div class="display-6">{{ amount }}</div>
                </div>

                <!-- Numeric Keypad -->
                <div class="d-grid gap-2 mb-3" [style.gridTemplateColumns]="'repeat(3, 1fr)'">
                    <button *ngFor="let key of keypad" class="btn btn-outline-dark" (click)="onKeyPress(key)">
                        {{ key }}
                    </button>
                </div>

                <!-- Action Buttons -->
                <div class="d-flex justify-content-end">
                    <button class="btn btn-primary"
                            [disabled]="amount === 0 || amount === undefined || saving"
                            (click)="addToCart()">Add to cart</button>
<!--                    <button class="btn btn-primary" (click)="addToCartAndGoNext()">Add to cart & Go next</button>-->
                </div>
            </div>

            <!-- Footer -->
            <div class="modal-footer">
                <button type="button"
                        [disabled]="saving"
                        class="btn btn-primary"
                        (click)="close()">
                    <span translation="Close" source=""></span>
                </button>

<!--                <button type="submit"-->
<!--                        [buttonBusy]="saving"-->
<!--                        [busyText]="l('SavingWithThreeDot')"-->
<!--                        class="btn btn-primary">-->
<!--                    <span translation="Skip" source=""></span>-->
<!--                </button>-->
            </div>
        </div>
    </div>
</div>
